import { Target } from '../@types';

const targetsForPricing: Target[] = [
  { value: 'name', type: 'text', isAPI: false },
];

export default targetsForPricing;
